import PropTypes from 'prop-types';
import { renderChildren } from '@blaze-cms/react-page-builder';
import getBlockClasses from './get-block-classes';
import { HIERARCHY_SHORT, COLUMN_CLASSES } from './constants';

const HierarchyShortCardsBlock = ({
  cardsSeparator,
  combined,
  channel,
  parsedChildren,
  withTitle
}) => {
  if (parsedChildren.length < 2) return null;

  return (
    <div
      data-testid="hierarchy-short-wrapper"
      className={getBlockClasses(HIERARCHY_SHORT, {
        cardsSeparator,
        combined,
        channel,
        withTitle
      })}>
      <div className={COLUMN_CLASSES}>{renderChildren(parsedChildren[0])}</div>

      <div className={COLUMN_CLASSES}>{renderChildren(parsedChildren[1])}</div>
    </div>
  );
};

HierarchyShortCardsBlock.propTypes = {
  cardsSeparator: PropTypes.bool.isRequired,
  combined: PropTypes.bool.isRequired,
  channel: PropTypes.string,
  parsedChildren: PropTypes.array.isRequired,
  withTitle: PropTypes.bool.isRequired
};

export default HierarchyShortCardsBlock;
